module.exports = __webpack_public_path__ + "static/img/5.993d9bc4.png";